import { useCallback, useEffect, useState } from 'react'
import fetchStopOvers from '../backend/stopovers'
import Stopover from '../types/Stopover'
import useLanguage from './useLanguage'

export default function useStopovers() {
  const [stopovers, setStopovers] = useState<Array<Stopover>>([])
  const [hasError, setHasError] = useState(false)
  const language = useLanguage()

  useEffect(() => {
    ;(async () => {
      try {
        if (stopovers.length === 0 && !hasError) {
          const data = await fetchStopOvers()
          setStopovers(data)
        }
      } catch {
        setHasError(true)
        return
      }
    })()
  }, [stopovers, hasError])

  const searchStopovers = useCallback(
    (searchValue: string) => {
      if (searchValue !== '') {
        return stopovers.filter((value) => {
          const normalizedSearch = searchValue
            .toLocaleLowerCase()
            .normalize('NFKD')
            .replace(/\p{Diacritic}/gu, '')
          const portName = value.port_name[language]
            .toLocaleLowerCase()
            .normalize('NFKD')
            .replace(/\p{Diacritic}/gu, '')
          return portName.includes(normalizedSearch)
        })
      }
      return []
    },
    [stopovers],
  )

  return { stopovers, hasError, searchStopovers }
}
